import { setPendingRoom } from "./roomFocus";
import { navigate } from "../../app/routes";

/**
 * Open map page and focus on a room
 */
export function openMapWithRoom(room: string): void {
  if (!room?.trim()) return;
  const trimmed = room.trim();
  setPendingRoom(trimmed);
  navigate(`/map?search=${encodeURIComponent(trimmed)}`);
}

/**
 * Create a click handler that opens map with room focus
 */
export function createRoomLinkHandler(room?: string): (() => void) | undefined {
  if (!room?.trim()) return undefined;
  return () => openMapWithRoom(room);
}
